import React from 'react'

import { sanitizeHtml } from '@/lib/helpers/domHelpers'

type Props<ElementType extends React.ElementType> = {
  html: string
  as?: ElementType
} & Omit<
  React.ComponentProps<ElementType>,
  'children' | 'dangerouslySetInnerHTML'
>

const SanitizedHtml = <ElementType extends React.ElementType = 'div'>({
  html,
  as,
  ...props
}: Props<ElementType>) => {
  const Component = as || 'div'

  return (
    <Component
      {...props}
      // eslint-disable-next-line no-restricted-syntax -- This component is the sanctioned wrapper around dangerouslySetInnerHTML
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
    />
  )
}

export default SanitizedHtml
